import { State } from '../StateTypes';
import { Navigation } from './navigationTypes';
import constants from '../../settings/constants';
/**
 * Select navigation slice state
 *
 * @param navigation
 */
export const selectNavigation = ({ navigation }: State): Navigation =>
  navigation;

/**
 * Select current view
 *
 * @param state
 */
export const selectCurrentView = (state: State): string =>
  selectNavigation(state).currentView;

/**
 * Selects first index of history
 *
 * @param state
 */
export const selectMostRecentHistory = (state: State) =>
  selectNavigation(state).history.length
    ? selectNavigation(state).history?.[0]
    : false;

/**
 * Returns true if current view matches param view
 *
 * @param view
 */
export const selectIsView = (view: string) => (state: State) =>
  selectCurrentView(state) === view;

export const selectIsCurrentViewStartView = (state: State) =>
  selectCurrentView(state) === constants.VIEW_NAMES.START;
